module.exports = __webpack_public_path__ + "static/media/reddit.1141ab17.svg";